<nz-form-item class="pf-form-item">
    @if (!!label) {
        <nz-form-label
            class="pf-form-label"
            [nzRequired]="pfRequired"
            [nzNoColon]="true"
            [title]="label"
            >{{ label }}
        </nz-form-label>
    }
    <nz-form-control class="pf-form-control" nzHasFeedback>
        <nz-switch
            class="pf-input"
            [nzLoading]="loading"
            [formControl]="formControl"></nz-switch>
    </nz-form-control>
</nz-form-item>
